<template>
  <section id="SortQuiz">
    <div>
      <h3>
        Rank the order of which countries are most affected by spam calls
      </h3>
      <transition
        name="fade"
        mode="out-in"
      >
        <div
          key="sortingQuizQuestion"
          v-if="!showAnswer"
        >

          <div class="sorting">
            <ul
              id="spamCallsPerMonth"
              class="sortable"
              ref="sortable"
            >
              <li
                v-for="country in countries"
                class="list-item"
                :key="country.name"
                :data-name="country.name"
              >
                {{ country.name }}
                <img
                  class="answer-icon answer-icon--wrong answer-icon--hidden"
                  src="@/assets/icons/cross-icon.svg"
                >
                <img
                  class="answer-icon answer-icon--correct answer-icon--hidden"
                  src="@/assets/icons/tick-icon.svg"
                >
              </li>
            </ul>
            <div class="sorting__info">
              Select and drag an option to change order from most calls to least calls
              <img src="@/assets/sorting.svg" />
            </div>
          </div>
          <button
            v-if="!answers.length"
            class="button"
            @click="submitAnswer"
          >Continue</button>
          <button
            v-else
            class="button"
            @click="revealAnswer"
          >Reveal answers</button>
          <button
            v-if="!answers.length"
            class="button button--plain"
            @click="revealAnswer"
          >No thanks, just show me the answers</button>
        </div>
        <div
          key="sortingQuizAnswer"
          v-else
        >
          <h4>Average spam calls per users / month</h4>
          <ul class="stats">
            <li
              class="stat"
              v-for="country in countries.sort((a,b) => a.order - b.order)"
              :key="country.name"
            >
              <div class="stat__bars">
                <div class="stat__label">{{ country.name }}</div>
                <div
                  class="stat__bar txt-sm"
                  :style="{maxWidth: `calc(${country.stats2020} / 49.9 * 100%)`}"
                >{{ country.stats2020 }}</div>
                <div
                  class="stat__bar txt-sm"
                  :style="{maxWidth: `calc(${country.stats2019} / 49.9 * 100%)`}"
                >{{ country.stats2019 }}</div>
              </div>
            </li>
            <li class="stats__legend">
              <div class="txt-sm">2020</div>
              <div class="txt-sm">2019</div>
            </li>
          </ul>
          <a
            href="https://tclr.se/36RRYDb"
            target="_blank"
            rel="noreferrer, noopener"
            class="button button--white c-purple"
            @click="$gtag.event('clicked_show_report', {
              'event_category' : 'outbound',
              'event_label' : 'show_report'
            })"
          >
            Show report
          </a>
        </div>
      </transition>
    </div>
    <QuizModal
      :title="quizModalTitle"
      :show="showQuizModal"
      :fb="fb"
      :tw="tw"
      :wa="wa"
      @close="showQuizModal = false"
    />
  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import QuizModal from "@/components/QuizModal";
import { Sortable } from "@shopify/draggable";
import { useGtag } from "vue-gtag-next";
import sharing from "@/share";
export default {
  components: {
    QuizModal,
  },
  setup() {
    const { event } = useGtag();
    const sort = ref(null);
    const sortable = ref(null);
    const showAnswer = ref(false);
    const answers = ref([]);
    const showQuizModal = ref(false);
    const quizModalTitle = ref(null);
    const countries = ref([
      { name: "Poland", order: 3, stats2019: "7.6", stats2020: "20.4" },
      { name: "Brazil", order: 0, stats2019: "45.6", stats2020: "49.9" },
      { name: "United States", order: 1, stats2019: "18.2", stats2020: "28.4" },
      { name: "Spain", order: 4, stats2019: "12.2", stats2020: "18.3" },
      { name: "Hungary", order: 2, stats2019: "2.3", stats2020: "28.3" },
    ]);

    const fb = ref(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        sharing.sortQuiz.url
      )}`
    );
    const tw = ref(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        sharing.sortQuiz.tw + " " + sharing.sortQuiz.url
      )}`
    );
    const wa = ref(
      `whatsapp://send?text=${encodeURIComponent(
        sharing.sortQuiz.wa + " " + sharing.sortQuiz.url
      )}`
    );

    function revealAnswer() {
      showAnswer.value = true;
      event("skipped_sort_quiz", {
        event_category: "quiz",
        event_label: "sort_quiz",
      });
    }

    function submitAnswer() {
      sort.value.destroy();
      const answerEls = Array.from(sortable.value.querySelectorAll("li"));
      let numberOfCorrectAnswers = 0;
      answers.value = answerEls.map((el) => el.textContent);
      answerEls.forEach((el, index) => {
        const name = el.dataset.name;
        const curr = countries.value.find((c) => c.name == name);
        setTimeout(() => {
          if (curr.order === index) {
            el.querySelector(".answer-icon--correct").classList.remove(
              "answer-icon--hidden"
            );
            numberOfCorrectAnswers++;
          } else {
            el.querySelector(".answer-icon--wrong").classList.remove(
              "answer-icon--hidden"
            );
          }
          if (index === answerEls.length - 1) {
            quizModalTitle.value = `${numberOfCorrectAnswers} out of ${countries.value.length}!`;
            showQuizModal.value = true;
          }
        }, index * 125);
      });
      event("completed_sort_quiz", {
        event_category: "quiz",
        event_label: "sort_quiz",
      });
    }

    onMounted(() => {
      sort.value = new Sortable(sortable.value, {
        draggable: "li",
      });
    });

    return {
      sortable,
      answers,
      countries,
      showAnswer,
      revealAnswer,
      submitAnswer,
      quizModalTitle,
      showQuizModal,
      fb,
      tw,
      wa,
    };
  },
};
</script>

<style>
#SortQuiz {
  justify-content: space-around;
  background-color: var(--purple);
  background-image: url("../assets/images/bg-pattern.png");
  background-position: center center;
  background-size: cover;
  padding: 20px;
  position: relative;
}

#SortQuiz > div:not(.QuizModal) {
  width: 100%;
  max-width: 960px;
  margin: 48px auto;
}

#SortQuiz h3 {
  font-size: 24px;
  line-height: 29px;
  margin-bottom: 13px;
}

#SortQuiz h4 {
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 13px;
}

.sorting {
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: column-reverse;
  justify-content: space-around;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.sorting__info {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  line-height: 17px;
  max-width: 245px;
  margin-bottom: 0;
}

.sorting__info img {
  display: block;
  margin: 24px auto;
}

.sortable {
  list-style: none;
  color: white;
  width: 100%;
  max-width: 600px;
  padding-left: 30px;
}
.sortable li {
  position: relative;
  margin-bottom: 16px;
  background: #fff;
  color: purple;
  cursor: grab;
  counter-increment: order;
  position: relative;
}
.answer-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  margin-top: -6px;
  width: 12px;
  height: auto;
  transition: all 0.25s ease;
}
.answer-icon--hidden {
  transform: scale(0.5, 0.5);
  opacity: 0;
}
.sortable li.draggable-mirror {
  min-width: 420px;
}

.sortable li:not(.draggable-mirror):before {
  content: counter(order);
  position: absolute;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  left: -30px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 500;
  color: #fff;
}

.sortable li.draggable--over,
.sortable li.draggable--original {
  background: transparent;
  color: transparent;
  border: 2px dashed white;
}

@media screen and (min-width: 720px) {
  #SortQuiz h3 {
    font-size: 56px;
    line-height: 68px;
    margin-bottom: 48px;
  }

  #SortQuiz h4 {
    font-size: 30px;
    line-height: 37px;
    margin-bottom: 48px;
  }

  #SortQuiz p {
    font-family: "Montserrat", sans-serif;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    max-width: 245px;
    margin-bottom: 0;
  }
  .sorting {
    display: flex;
    align-items: center;
    flex-flow: row;
    justify-content: space-around;
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
  }
  .sorting__info {
    text-align: left;
    margin-left: 40px;
  }
  .sorting__info img {
    margin: 24px 0;
  }
  @media screen and (min-width: 1200px) {
    .sorting__info {
      position: absolute;
      right: 0;
      transform: translateX(100%);
    }
  }
}
</style>